import React, { useEffect, useState } from "react";
import { Table, Dropdown, Menu, Button, message, Popconfirm } from "antd";
import { MoreOutlined, PlusOutlined } from "@ant-design/icons";
import { deleteProductTableData, getMyProducts } from "../../api";
import { Link, useNavigate } from "react-router-dom";

const MyProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate= useNavigate()
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

  // Fetch products from backend with pagination
  const fetchProducts = async (page = 1, limit = 10) => {
    setLoading(true);
    try {
      const response = await getMyProducts(page, limit);
      if (response.data.userProducts) {
        setProducts(response.data.userProducts.docs);
        setPagination({
          current: page,
          pageSize: limit, // ✅ Now using `limit`
          total: response.data.userProducts.totalDocs,
        });
      }
    } catch (error) {
      console.error("Error fetching products:", error);
      message.error("Failed to load products.");
    }
    setLoading(false);
  };

  // Fetch data on component mount
  useEffect(() => {
    fetchProducts();
  }, []);

  // Handle pagination change
  const handleTableChange = (pagination) => {
    fetchProducts(pagination.current, pagination.pageSize); // ✅ Now using `limit`
  };

  // Handle product deletion
  const deleteProduct = async (productId) => {
    try {
      const response = await deleteProductTableData(productId);
      if (response.data.message === "Product deleted successfully") {
        message.success("Product deleted successfully.");
        fetchProducts(pagination.current, pagination.pageSize); // ✅ Refresh with correct pagination
      } else {
        message.error(response.data.message || "Failed to delete product.");
      }
    } catch (error) {
      console.error("Error deleting product:", error);
      message.error("Failed to delete product.");
    }
  };

  // Define menu actions
  const menu = (record) => (
    <Menu>
      <Menu.Item key="edit" onClick={() => navigate(`/edit-product/${record?._id}`)}>
        Edit
      </Menu.Item>
      <Menu.Item key="delete">
        <Popconfirm
          title="Are you sure to delete this product?"
          onConfirm={() => deleteProduct(record._id)}
          okText="Yes"
          cancelText="No"
        >
          Delete
        </Popconfirm>
      </Menu.Item>
    </Menu>
  );

  // Define columns for the table
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      render: (price) => `$${price.toFixed(2)}`,
    },
    {
      title: "Project Name",
      dataIndex: ["project", "projectName"],
      key: "projectName",
      render: (text, record) => {
        const projectId = record.project?.projectId; // Project ID from project field
        const projectMongoId = record.project?._id; // MongoDB Object ID of project

        if (!projectId || !projectMongoId) return "N/A"; // Handle missing project data

        return (
          <Link
            to={`/project/${projectId}?projectId=${projectMongoId}`}
            style={{ textDecoration: "underline", color: "#1890ff" }} // Ant Design link color
          >
            {record.project?.projectName || "N/A"}
          </Link>
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <Dropdown overlay={menu(record)} trigger={["click"]}>
          <Button shape="circle" icon={<MoreOutlined />} />
        </Dropdown>
      ),
    },
  ];

  return (
    <div>
      <h2>Products List</h2>
      <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => navigate("/create-product")} 
        >
          Add Product
        </Button>
      <Table
        columns={columns}
        dataSource={products}
        rowKey="_id"
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange} 
      />
    </div>
  );
};

export default MyProducts;
